import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { RelationshipPage } from '#/components/ontology/relationship-page'
import { typePageSearchSchema } from '#/components/ontology/search'
import { useOntologyExplorer } from '#/components/ontology/use-ontology-explorer'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/ontology/relationships/$relName',
)({
  validateSearch: typePageSearchSchema,
  component: RelationshipRoute,
})

function RelationshipRoute() {
  const { t } = useTranslation()
  const { relName } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { doc } = useOntologyExplorer()
  const rel = doc.relationship_types.find((rt) => rt.name === relName)

  if (!rel) {
    return (
      <p className="p-8 text-sm text-muted-foreground">
        {t('ontology.relationshipNotFound')}
      </p>
    )
  }

  return (
    <RelationshipPage
      doc={doc}
      rel={rel}
      tab={tab ?? 'relationships'}
      onTabChange={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            tab: next === 'relationships' ? undefined : next,
          }),
          replace: true,
        })
      }}
    />
  )
}
